import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../Button";
import Loading from "../Loading";
import LoginButton from "./LoginButton";
import LogoutButton from "./LogoutButton";

const AuthenticationButtons = () => {
  const navigate = useNavigate()
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <Loading />;
  }
  if (isAuthenticated) {
    return (
      <>
        <Button
          size="sm"
          onClick={() => { navigate('/Account') }}
        >
          My Account
        </Button>
        <LogoutButton />
      </>
    );
  } else {
    return (
      <>
        <a
          href="/Welcome"
        >
          <Button
            size="sm"
            textColor={{ color: 'white' }}
            backgroundColor={{ background: '#4c256c' }}
            border={{ border: 'solid #9264b7 6px' }}
          >
            Get Started
          </Button>
        </a>
        <LoginButton />
      </>
    );
  }
};

export default AuthenticationButtons;
